import React, { useState } from "react";
import Layout from "../../components/layout/Layout";
import { useLocation, useNavigate } from "react-router-dom";
import { formatDate } from "../../helpers/DateConversion";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function ViewPinCode() {
  const location = useLocation();
  const data = location.state.data;

  console.log("data", data);

  return (
    <div>
      <Layout>
        <div className="bg-white md:p-10 p-3 rounded-xl shadow-md mt-8">
          <div className="flex justify-between items-center">
            <h2 className="text-xl font-medium">View Order</h2>
          </div>
          <div className="mt-10">
            <div className="flex my-6">
              <div className="w-1/2">
                <h6 className="text-sm font-medium">Pincode</h6>
                <p className="mt-1">{data.number}</p>
              </div>
              <div className="w-1/2">
                <h6 className="text-sm font-medium">PinType</h6>
                <p className="mt-1">{data.pinType}</p>
              </div>
            </div>
            <hr />

            <div className="flex my-6">
              {/* <div className="w-1/2">
                <h6 className="text-sm font-medium">Quantity</h6>
                <p className="mt-1">{data.quantity}</p>
              </div> */}
              <div className="w-1/2">
                <h6 className="text-sm font-medium">Created At</h6>
                <p className="mt-1">{data.createdAt}</p>
              </div>
            </div>
           
          </div>
        </div>
      </Layout>
    </div>
  );
}
